module.exports = __webpack_public_path__ + "static/media/krb.e27e93ca.svg";